/* eslint-disable react/no-did-mount-set-state */
import Uppy from 'uppy/lib/core';
import { Dashboard } from 'uppy/lib/react';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import { Form } from 'react-form';
import { obtenirAffaire, telechargerFichier, envoyerMessageNG, obtenirPrestation } from '../../App_Code/API';
import { estHTML, toDate, getGlyphe, nettoyerObjetEmail, fromNow } from '../../App_Code/Utils';
import * as MesAct from '../../Actions/MesActions';
import { mapStateToPropsWrapper, verificationLocationState } from '../CaptureErreurs';
import { LigneCard } from '../Card';
import Chargement from '../Chargement';
import { ZoneTexte } from '../ChampFormulaire';
import SensCommunication from '../../App_Data/SensCommunication';
import IconeBureau from '../../App_Data/IconeBureau';
// import EtatTicket from './EtatTicket';

const francaisCore = {
    strings: {
        youCanOnlyUploadX: {
            0: 'Vous pouvez joindre %{smart_count} fichier au maximum',
            1: 'Vous pouvez joindre %{smart_count} fichiers au maximum',
        },
        youHaveToAtLeastSelectX: {
            0: 'You have to select at least %{smart_count} file',
            1: 'You have to select at least %{smart_count} files',
        },
        exceedsSize: 'Ce fichier dépasse la taille maximale autorisée : ',
        youCanOnlyUploadFileTypes: 'Types de fichiers pris en charge :',
        uppyServerError: 'Connection with Uppy Server failed',
    },
};

const francaisDashboard = {
    strings: {
        selectToUpload: 'Select files to upload',
        closeModal: 'Close Modal',
        upload: 'Upload',
        importFrom: 'Import from',
        dashboardWindowTitle: 'Uppy Dashboard Window (Press escape to close)',
        dashboardTitle: 'Uppy Dashboard',
        copyLinkToClipboardSuccess: 'Link copied to clipboard.',
        copyLinkToClipboardFallback: 'Copy the URL below',
        copyLink: 'Copy link',
        fileSource: 'File source',
        done: 'Done',
        name: 'Name',
        removeFile: 'Remove file',
        editFile: 'Edit file',
        editing: 'Editing',
        finishEditingFile: 'Finish editing file',
        localDisk: 'Local Disk',
        myDevice: 'My Device',
        dropPasteImport: 'Drop files here, paste, import from one of the locations above or',
        dropPaste: 'Glissez-déposez vos fichiers ici, ou',
        browse: 'cliquez ici pour les sélectionner',
        fileProgress: 'File progress: upload speed and ETA',
        numberOfSelectedFiles: 'Number of selected files',
        uploadAllNewFiles: 'Upload all new files',
        emptyFolderAdded: 'No files were added from empty folder',
        uploadComplete: 'Upload complete',
        resumeUpload: 'Resume upload',
        pauseUpload: 'Pause upload',
        retryUpload: 'Retry upload',
        uploadXFiles: {
            0: 'Upload %{smart_count} file',
            1: 'Upload %{smart_count} files',
        },
        uploadXNewFiles: {
            0: 'Upload +%{smart_count} file',
            1: 'Upload +%{smart_count} files',
        },
        folderAdded: {
            0: 'Added %{smart_count} file from %{folder}',
            1: 'Added %{smart_count} files from %{folder}',
        },
    },
};

const formatDate = 'dddd Do MMMM YYYY [à] HH:mm';

const Entete = ({ message, prest, nbMess }) => {
    /* Sous-composant */
    // icone
    const Icone = ({ path, couleur }) => (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width={22} height={22} style={{ filter: 'invert(1)' }}>
            <image xlinkHref={path} width={22} height={22}/>
        </svg>
    );

    return (
        <div className="timeline">
            <div className="card">
                <div className="card-body">
                    <div className="row d-flex align-items-center">
                        <div className="order-2 col-2 order-xl-0 col-xl-1">
                            <IconeBureau idBureau={message.Bureau} taille="fa-3x" title={message.LibBureau} />
                        </div>
                        <div className="order-0 col-12 order-xl-1 col-xl-6 align-self-center">
                            <div className="row d-flex">
                                { prest && prest.Icone ?
                                    <div className="d-flex align-items-center justify-content-center" title={message.LibPrest} style={{ height: 25, width: 25, borderRadius: '50%', backgroundColor: prest.Couleur }}>
                                        <Icone path={prest.Icone} couleur={prest.Couleur} /> {' '}
                                    </div> :
                                    <div className="d-flex align-items-center justify-content-center" style={{ height: 28, width: 28, color: '#6c757d' }} title={message.LibPrest}>
                                        <svg width="25" height="25" viewBox="0 0 16 16" className="bi bi-question-circle" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                            <path fillRule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                            <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                                        </svg>
                                    </div>
                                }
                                <h4 className="col-11 w-100 d-inline-block text-truncate">
                                    {nettoyerObjetEmail(message.Objet)}
                                </h4>
                            </div>
                            <span className="text-muted font-italic">{`Affaire n° ${message.NumAff}`}</span>
                        </div>
                        <div className="order-3 col-10 order-xl-2 col-xl-5 align-self-center">
                            <LigneCard titre="Début de la conversation" valeur={fromNow(message.DateSaisie, 'DD/MM/YYYY HH:mm')} longTitre derniereLigne />
                            <LigneCard titre="Nombre de messages" valeur={nbMess} longTitre derniereLigne />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const Message = ({
    numMess, NumLigne, DateSaisie, Ind1, Memo, SensCom, LsFichiers, estMessageSyndic,
}) => {
    /* Corps du texte */
    let Texte = '';
    if (estHTML(Memo)) {
        Texte = <div dangerouslySetInnerHTML={{ __html: Memo }} />;
    } else {
        Texte = Memo.split('\n').map((item, key) => (
            <span key={key}>
                {item}
                <br />
            </span>
        ));
    }

    /* Pièces jointes */
    const PJ = LsFichiers.map((fichier, i) => (
        <span key={i}>
            {i > 0 && ' | '}
            <a target="_blank" href={telechargerFichier(fichier.Token)}>
                {fichier.Nom || `Fichier sans nom n°${i + 1}`}
            </a>
        </span>
    ));

    const oSensCom = SensCommunication(SensCom)

    return (
        <div className="timeline">
            <div className="card" id={`${numMess + 1}`}>
                <div className="card-header" style={{ backgroundColor : SensCom == 1 || SensCom == 11 ? '#cdffbd8c' : '#d6ccff8c' }}>
                    <div className="d-flex justify-content-between">
                        <span>
                            {/* <img src={getGlyphe(Ind1, estMessageSyndic)} alt={Ind1.Nom} />  */}
                            <i className={`mt-1 ${oSensCom.Icone}`} title={oSensCom.Type}/>{' '}
                            <b> {Ind1.Nom}</b>, le{' '}
                            {toDate(DateSaisie, formatDate)}
                        </span>
                        {/* <i className={`mt-1 ${oSensCom.Icone} fa-lg`} title={oSensCom.Type}/> */}
                        {/* <a href={`#${NumLigne + 1}`}>#{NumLigne + 1}</a> */}
                    </div>
                </div>
                <div className="card-body">
                    <p className="card-text">{Texte}</p>
                </div>
                {LsFichiers.length > 0 && (
                    <div className="card-footer text-muted">
                        <i className="fas fa-paperclip" /> {PJ}
                    </div>
                )}
            </div>
        </div>
    );
};

/* const Evenement = ({ Nom, Code, DataSai }) => (
    <div className="event">
        <span className="ml-0 mr-1 fa-stack fa-1x">
            <i className="fas fa-circle fa-stack-2x cercle" />
            <strong className="fa-stack-1x fa-stack-text">
                <i className={`text-dark fas ${Actions.find(a => a.code === Code).icone}`} />
            </strong>
        </span>
        <i className="text-muted">
            {Nom} {Actions.find(a => a.code === Code).lib} {toDate(DataSai, formatDate)}
        </i>
    </div>
); */

const Formulaire = ({
    Nom, nombreMessages, defaultValues, handleChange, handleSubmit, inputs, uppy
}) => (
    <div className="card mb-3" id={`${nombreMessages + 1}`}>
        <div className="card-header">
            <div className="d-flex justify-content-between">
                <span>
                    <i className="fa fa-pencil-square-o" aria-hidden="true" /> <b>Saisir une réponse</b>
                </span>
                {/* <a href={`#${nombreMessages + 1}`}>#{nombreMessages + 1}</a> */}
            </div>
        </div>
        <Form
            defaultValues={defaultValues}
            onChange={formState => handleChange(formState)}
            onSubmit={submittedValues => handleSubmit(submittedValues)}
        >
            {formApi => (
                <form onSubmit={formApi.submitForm}>
                    <div className="row card-text">
                        <div className="col-12 col-xl-8">
                            <ZoneTexte field="Memo" id="Memo" type="text" rows={9} style={{backgroundColor: "#f2f2f2"}} />
                        </div>
                        <div className="col-12 col-xl-4" style={{ alignSelf: 'center', height: 225 }}>
                            <div className="uppy-container mb-3">
                                <Dashboard
                                    uppy={uppy}
                                    width={10000}
                                    height={225}
                                    locale={francaisDashboard}
                                    hideUploadButton
                                    proudlyDisplayPoweredByUppy={false}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="card-footer text-muted">
                        <div className="form-group text-center">
                            <button className="btn btn-success" type="submit" ref={inputs.Envoyer} disabled>
                                Envoyer le message
                            </button>
                        </div>
                    </div>
                </form>
            )}
        </Form>
    </div>
);

const Pied = () => null;

class PageTicket extends Component {
    constructor(props) {
        super(props);
        this.constructed = true;

        this.inputs = [];
        this.inputs.Memo = React.createRef();
        this.inputs.Envoyer = React.createRef();

        this.uppy = Uppy({
            debug: false,
            autoProceed: true,
            restrictions: {
                maxFileSize: 209715200,
                maxNumberOfFiles: 10,
                allowedFileTypes: ['image/*', 'text/*', 'application/pdf'],
            },
            locale: francaisCore,
        })
            .on('upload', () => this.setState({ LsFichiers: [] }))
            .on('complete', this.handleComplete)
            .on('file-removed', this.handleFileRemoved)
            .run();

        this.defaultValues = {
            Memo: `Bonjour,\n\n\n\nCordialement\n${this.props.NomPro}`,
        };

        this.state = {
            affaire: undefined,
            prest: undefined,
            LsFichiers: [],
            scrolled: 0,
        };
    }

    componentDidMount() {
        const { NumAff, affaire } = this.props.location.state;

        if (!affaire) {
            obtenirAffaire(NumAff).then((aff) => {
                this.setState({ affaire: aff });
                obtenirPrestation(aff[0].Prest).then((prest) => {
                    this.setState({ prest });
                });
                // scroll directement jusqu'au dernier message de l'affaire
                document.getElementById(`${aff.length}`).scrollIntoView({ behavior: 'smooth',block: "end"})
            });
        } 
        else {
            this.setState({ affaire });
            obtenirPrestation(affaire[0].Prest).then((prest) => {
                this.setState({ prest });
            });
            // document.getElementById(`${affaire.length}`).scrollIntoView({ behavior: 'smooth',block: "end"})
        }
        
        window.addEventListener('scroll', this.listenToScroll)
    }

    componentWillUnmount() {
        this.uppy.close();
        if (this.unblock) this.unblock();
    }

    listenToScroll = () => {
        const winScroll =
          document.body.scrollTop || document.documentElement.scrollTop;

        const height =
          document.documentElement.scrollHeight -
          document.documentElement.clientHeight;

        const scrolled = winScroll / height;

        this.setState({ scrolled })
    }

    toForm = () => {
        document.getElementById(`${this.state.affaire.length + 1}`).scrollIntoView({ behavior: 'smooth',block: "end"})
    }

    handleFileRemoved = (file) => {
        this.setState(prevState => ({
            LsFichiers: prevState.LsFichiers.filter(fichier => fichier.Nom !== file.name),
        }));
    };

    handleComplete = (result) => {
        result.successful.forEach((file) => {
            const reader = new FileReader();

            reader.onload = (upload) => {
                this.setState(prevState => ({
                    LsFichiers: [...prevState.LsFichiers, { Data: upload.target.result.split(',')[1], Nom: file.name }],
                }));
            };
            reader.readAsDataURL(file.data);
        });
    };

    handleChange = (formState) => {
        const affichePrompt = formState.values.Memo !== this.defaultValues.Memo;
        this.inputs.Envoyer.current.disabled = !affichePrompt;
        if (!this.unblock && affichePrompt) {
            this.unblock = this.props.history.block("Vous n'avez pas envoyé le message.<br>Voulez-vous vraiment quitter cette page ?");
        } else if (this.unblock && !affichePrompt) {
            this.unblock();
        }
    };

    handleSubmit = (submittedValues) => {
        this.inputs.Envoyer.current.disabled = true;

        const { Memo } = submittedValues;
        const { affaire, LsFichiers } = this.state;
        const { NumAuto, Objet } = affaire[0];
        const sObjet = Objet.startsWith('RE :') || Objet.startsWith('Re:') ? Objet : `RE : ${Objet}`;
        // const sMemo = `${Memo}\n${this.props.NomPro}`;
        /* const ObjetValide = this.defaultValues.Objet !== Objet && !estVide(Objet);
        AfficherFeedback(this.inputs.Objet, ObjetValide);

        const MemoValide = this.defaultValues.Memo !== Memo;
        AfficherFeedback(this.inputs.Memo, MemoValide);

        if (!ObjetValide || !MemoValide) {
            this.inputs.Envoyer.current.disabled = false;
            return;
        } */
        const bureau = affaire[0].Bureau;
        const prest = affaire[0].Prest;
        envoyerMessageNG(NumAuto, {
            Objet: sObjet, Memo, LsFichiers, Bureau: bureau, Action: 'REP', Prest: prest
        }).then((data) => {
            if (data && data > 0) {
                swal('Envoyé', 'Le message a été envoyé avec succès.', 'success');
                if (this.unblock) this.unblock();
                this.props.actions.mesObtenirMessages();
                this.props.history.push('/MaMessagerie')
            } else {
                swal('Erreur', 'Le message n&apos;a pas été envoyé.', 'error');
                this.inputs.Envoyer.current.disabled = false;
            }
        });
    };

    render() {
        const { NomPro, cloture } = this.props;
        const { affaire, scrolled, prest } = this.state;
        if (affaire === undefined) return <Chargement />;
        const lsMessages = affaire.slice(0).sort((m1, m2) => m1.NumLigne - m2.NumLigne);

        return (
            <React.Fragment>
                <Entete message={lsMessages[0]} prest={prest} nbMess={lsMessages.length}/>
                {/* affaire.map((message, i) => (message.Act === 'MES' ? <Message key={i} {...message} /> : <Evenement key={i} {...message} />)) */}
                {lsMessages.map((message, i) => (
                    <Message key={i} {...message} numMess={i} estMessageSyndic={message.SensCom === 2 || message.SensCom === 12} />
                ))}
                {cloture ? <Pied /> : <Formulaire Nom={NomPro} nombreMessages={lsMessages.length} {...this} />}
                {scrolled < 0.9  ? 
                    <button type="button" className="btn btn-success btn-lg" onClick={this.toForm} style={{ position: 'fixed', bottom: 20, right: 20, borderRadius: '50%' }} title="Accéder au formulaire de rédaction d'une réponse">
                        <i className="fa fa-pencil-square-o" aria-hidden="true" />
                    </button> : null
                }
            </React.Fragment>
        );
    }
}
PageTicket.displayName = 'PageTicket';
PageTicket.requiredLocationState = [
    'NumAff', // Numéro de l'affaire
];

function mapStateToProps({
    AdhStore: { Adh },
    ProStore: {
        Pro: { Ind },
    },
}) {
    return { NomAdh: Adh.Nom, NomPro: Ind.Nom };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(MesAct, dispatch) };
}

export default connect(mapStateToPropsWrapper(mapStateToProps), mapDispatchToProps)(verificationLocationState(PageTicket));



// WEBPACK FOOTER //
// ./src/components/MaMess/PageTicketNG.js